import Vue from 'vue'
import Router from 'vue-router'
import brightmain from 'components/bright-main/bright-main'
import aboutUs from 'components/about-us/about-us'
import helpLayout from 'components/helplayout/helplayout'
import linkUs from 'components/link-us/link-us'
import prouductCenter from 'components/prouduct-center/prouduct-center'
import seriveTek from 'components/serive-tek/serive-tek'
import Responsibility from 'components/Responsibility/Responsibility'
import Mperson from 'components/m-person/m-person'
import Page from 'components/prouduct-detail/prouduct-detail'
import Page1 from 'components/prouduct-detail/modified-plastics'
import inlineChat from 'components/inline-chat/inline-chat'

Vue.use(Router)

export default new Router({
    // mode: 'history',
    // scrollBehavior(to,from,savePosition) {
    //     console.log(to)
    //     // console.log(from)
    //     // console.log(savePosition)
    //     const position = {}
    //     if(to.hash){ //先判断目标路由有没有hash值
    //     position.selector = to.hash
    //     }
    //     return position
    //  },
  routes: [
    {
      path: '/',
      redirect: '/brightmain'
    },
    {
    	path: '/brightmain',
    	component: brightmain
    },
    {
    	path: '/aboutUs',
    	component: aboutUs
    },
    {
    	path: '/help',
    	component: helpLayout
    },
    {
    	path: '/linkUs',
    	component: linkUs
    },
    {
        path: '/prouductCenter',
        component: prouductCenter,
        children: [
            {
                path: "",
                component: Page
            }
        ]
    },
    {
        path: '/prouductCenter/:id',
        component: Page1
    },
    {
        path: '/seriveTek',
        component: seriveTek
    },
    {
        path: '/Responsibility',
        component: Responsibility
    },
    {
        path: '/Mperson',
        component: Mperson
    },
    {
        path: '/inlineChat',
        component: inlineChat
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js